import { render, staticRenderFns } from "./RegisCard.vue?vue&type=template&id=2f312501&scoped=true&"
import script from "./RegisCard.vue?vue&type=script&lang=js&"
export * from "./RegisCard.vue?vue&type=script&lang=js&"
import style0 from "./RegisCard.vue?vue&type=style&index=0&id=2f312501&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f312501",
  null
  
)

export default component.exports